/**
 * Ticket Category Constants
 *
 * Complete `ticket_category` value set (mirrored by codegen `Ticket_Category`).
 * Use `z.enum(TICKET_CATEGORY_VALUES)` for tool/form input — never a hand-typed
 * literal array. `satisfies readonly Ticket_Category[]` breaks `tsc` if the DB
 * enum drifts after codegen.
 */

import type { Ticket_Category } from "@/src/gql/graphql";

export const TICKET_CATEGORY_VALUES = [
  "backup",
  "cloud",
  "email",
  "hardware",
  "network",
  "other",
  "phone",
  "printer",
  "security",
  "software",
] as const satisfies readonly Ticket_Category[];
